module.exports = __webpack_public_path__ + "static/media/bursts_02.6cdfa90e.svg";